import { UserProfileSchema, SendPhoneCodeResponseSchema, VerifyPhoneCodeResponseSchema, } from '@packages/types';
import { api } from '../client.js';
export function getMe() {
    return api('/user/me', UserProfileSchema);
}
export function updateProfile(data) {
    return api('/user/me', UserProfileSchema, { method: 'PATCH', body: data });
}
export function sendPhoneCode(data) {
    return api('/user/me/phone/send-code', SendPhoneCodeResponseSchema, { method: 'POST', body: data });
}
export function verifyPhoneCode(data) {
    return api('/user/me/phone/verify-code', VerifyPhoneCodeResponseSchema, { method: 'POST', body: data });
}
export function removePhone() {
    return api('/user/me/phone', UserProfileSchema, { method: 'DELETE' });
}
